export default "__VITE_ASSET__FZduJcZD__"